@if (formFieldSignal(); as formField) {
    <div class="flex flex-col gap-2">
        @if(!isInGrid) {
            <label class="flex gap-1 text-sm font-semibold" [for]="formField.Id">
                <div class="flex items-center" [innerHTML]="formField.Caption"></div>
                @if(formField?.aiGeneration !== undefined){
                    @if (formField?.aiGeneration?.aiValue !== undefined) {
                        @if (formField?.aiGeneration?.confirmed){
                            <i class="fa-solid fa-microchip-ai ml-2 text-sm text-green-500"></i>
                        }@else if (formField?.aiGeneration?.confirmed !== undefined) {
                            <i (click)="setAiButtonAcceptance(formField)" class="fa-solid fa-microchip-ai ml-2 text-sm text-blue-500"></i>
                        }
                    } @else if(formField?.aiGeneration?.generated) {
                        <bizz-tooltip
                                class="relative -top-2 inline-flex h-5 cursor-pointer text-xl leading-4 text-orange-400"
                                text="{{'AiCouldNotProcess' | translate }}"></bizz-tooltip>
                    }
                }
                @if (formField.IsRequired) {
                    <span class="relative -top-1 h-5 text-xl leading-tight text-red-400">*</span>
                }
                @if (formField && formField.Hint) {
                    <bizz-popup class="ml-1" [title]="formField.Caption" [body]="formField.Hint"></bizz-popup>
                }
                @if (errorState?.AiValidationError === undefined && errorState?.Message; as errorMessage) {
                    <bizz-tooltip
                            class="relative -top-2 inline-flex h-5 cursor-pointer text-xl leading-4 text-red-400"
                            [text]="errorMessage"></bizz-tooltip>
                }
                @else if(formControl.invalid){
                    <bizz-tooltip class="relative -top-2 inline-flex h-5 cursor-pointer text-xl leading-4 text-red-400"  [text]="'Info_ProvideEmail' | translate"></bizz-tooltip>
                }
            </label>
        }
        <div class="input-button-group flex" [ngClass]="{'hidden' : formField.IsHidden}">
            <input #input [readOnly]="readOnlyOverride || formField.IsReadOnly"
                [ngClass]="{'border-red-400': formControl.dirty && formControl.invalid}"
                [tabIndex]="readOnlyOverride || formField.IsReadOnly ? -1  : 0"
                [formControl]="formControl"
               [class.error]="errorState?.AiValidationError === undefined && errorState != null"
               [class.errorYellow]="!formField.aiGeneration?.confirmed && formField.aiGeneration?.generated && errorState != null && errorState.AiValidationError"
                id="{{formField.Id}}"
                placeholder="{{formField.Placeholder}}"
                type="email">
            <div class="button-group">
                <button type="button"
                        class="default !px-2 !py-1"
                        [class.error]="errorState?.AiValidationError === undefined && errorState != null"
                        [class.errorYellow]="!formField.aiGeneration?.confirmed && formField.aiGeneration?.generated && errorState != null && errorState.AiValidationError"
                        [disabled]="formControl.invalid"
                        (click)="openMailClient()">
                    <bizz-icon class="h-4 w-4" iconName="envelope"></bizz-icon>
                </button>
            </div>
        </div>
    </div>
}
